const PUBLIC_URL = process.env.PUBLIC_URL || '';

const cardsData = [
    { id: 1, name: 'cat', image: `${PUBLIC_URL}/images/cat.webp` },
    { id: 2, name: 'dog', image: `${PUBLIC_URL}/images/dog.webp` },
    { id: 3, name: 'lion', image: `${PUBLIC_URL}/images/lion.webp` },
    { id: 4, name: 'fox', image: `${PUBLIC_URL}/images/fox.webp` },
    { id: 5, name: 'bear', image: `${PUBLIC_URL}/images/bear.webp` },
    { id: 6, name: 'frog', image: `${PUBLIC_URL}/images/frog.webp` },
    { id: 7, name: 'monkey', image: `${PUBLIC_URL}/images/monkey.webp` },
    { id: 8, name: 'panda', image: `${PUBLIC_URL}/images/panda.webp` },
];

export default cardsData;
